import React from 'react';

// The highest number a 32 bit int can hold
export const MAX_INT32 = 2147483647;

// Checks whether a keyboard event is an input action key (backspace, arrow left/right, tab or enter)
export const isActionKeyEvent = (event: React.KeyboardEvent<any>): boolean => {
  return (
    event.ctrlKey ||
    ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(event.key)
  );
};

// Checks whether a numeric value is positive
export const isPositiveInteger = (input: string | number) => {
  return !!`${input}`.match(/^[0-9]*$/);
};

// Typesafe nil check which can be used within an array.filter
export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

// Generates a random hexadecimal ID of the given length
export const generateHexId = (length: number): string => {
  return [...Array(length)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');
};

export const defaultTranslateFn = (key: string): string => {
  return DEFAULT_TRANSLATION_MAP[key] || key;
};

const DEFAULT_TRANSLATION_MAP: { [n: string]: string } = {
  'days.su': 'su',
  'days.mo': 'mo',
  'days.tu': 'tu',
  'days.we': 'we',
  'days.th': 'th',
  'days.fr': 'fr',
  'days.sa': 'sa',
};

export const sleep = async (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(undefined), ms);
  });
};
